import React from 'react';
import { Box } from '@mui/material';
import { string } from 'prop-types';

const capitalize = e => e.charAt(0).toUpperCase().concat(e.slice(1).toLowerCase());

const Employee = ({ name, surname }) => (
  <Box
    sx={{
      height: '29px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSize: '24px',
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: '-0.6px',
      color: 'primary.ultraDark',
    }}
  >
    {capitalize(name)} {capitalize(surname)}
  </Box>
);
Employee.propTypes = {
  name: string.isRequired,
  surname: string.isRequired,
};

export default Employee;
